import { IAppState } from '../../../../../AppModulesWrapper';

export const selectIsRecommendedPackageCheckoutFillBalance = (state: IAppState): boolean => {
  return state.servicePickerWidgetV2.recommendedPackages.isFillBalance;
};
